import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AcademyCommonModule } from '@draeger-academy/common';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { DaLinkModule } from '../da-link';
import { PersonFormComponent } from './person-form.component';

// const routes: Routes = [{ path: '', component: ImprintComponent }];

@NgModule({
    declarations: [PersonFormComponent],
    exports: [PersonFormComponent],
    imports: [
        ReactiveFormsModule,
        RouterModule,
        CommonModule,
        FormsModule,
        AcademyCommonModule,
        ReactiveFormsModule,
        // please do not change the order of the next 3 imports
        TranslateModule.forChild(),
        // RouterModule.forChild(routes),
        LocalizeRouterModule.forChild([])
    ],
    providers: []
})
export class PersonFormModule {}
